import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const HelpGuides = lazy(() => import('./pages/HelpGuides'));

export const helpRoutes: RouteObject = {
  path: 'help',
  handle: { breadcrumb: 'Help & Guides' },
  children: [
    {
      index: true,
      element: <HelpGuides />,
    },
  ],
};
